// @docs https://[domain]/api/v1/docs
export default {
  List: "/master-data/districts",
};
